import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type MutationFunction, useRequest } from '../common';
import {
  getIntegrationTemplateLogoListKey,
  getIntegrationTemplateLogoDetailsKey,
} from './keys';

//This create an integration template logo, overwrites QueryData for that individual template,
//and invalidates all related integration template list queries
export const useCreateIntegrationTemplateLogo: MutationFunction<any, any> = ({
  query,
  requestOptions,
  queryOptions,
} = {}) => {
  const queryClient = useQueryClient();
  const request = useRequest(requestOptions);

  return useMutation(
    (body) => {
      return request(`/managed_integrations/logo`, {
        query,
        init: { method: 'POST', body },
      });
    },
    {
      ...queryOptions,
      mutationKey: ['createIntegrationTemplateLogo'],
      onSuccess: (data, requestData, ...rest) => {
        const key = getIntegrationTemplateLogoDetailsKey(data.uuid);
        queryClient.setQueryData(key, data);
        queryClient.invalidateQueries({
          queryKey: getIntegrationTemplateLogoListKey(),
        });
        queryOptions?.onSuccess?.(data, requestData, ...rest);
      },
    },
  );
};

//This deletes an integration template logo, overwrites QueryData for that individual template,
//and invalidates all related integration template list queries
export const useDeleteIntegrationTemplateLogo: MutationFunction<
  unknown,
  string
> = ({ query, requestOptions, queryOptions } = {}) => {
  const queryClient = useQueryClient();
  const request = useRequest(requestOptions);

  return useMutation(
    (logoId) => {
      return request(`/managed_integrations/logo/${logoId}`, {
        query,
        init: { method: 'DELETE' },
      });
    },
    {
      ...queryOptions,
      mutationKey: ['deleteIntegrationTemplateLogo'],
      onSuccess: (data, logoId, ...rest) => {
        const key = getIntegrationTemplateLogoDetailsKey(logoId);
        queryClient.setQueryData(key, data); // Do we need this?
        queryClient.invalidateQueries({
          queryKey: getIntegrationTemplateLogoListKey(),
        });
        queryOptions?.onSuccess?.(data, logoId, ...rest);
      },
    },
  );
};

export default {
  useCreateIntegrationTemplateLogo,
  useDeleteIntegrationTemplateLogo,
};
